// @ts-nocheck
import { TrackViewMiniCartParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackViewMinicart";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";
// Store Custom Code
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { KitModel } from "@store/Overrides/Widgets/ProductDetails/ProductDetailsKitSectionOptions";

const useTrackViewStoreCart = (
    parameters: PartialSpecific<TrackViewMiniCartParameters & { isMiniCart?: boolean }, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackViewMiniCartParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (
        parameters: Partial<TrackViewMiniCartParameters & { isMiniCart?: boolean }> = {},
        options?: Toolkit.GoogleAnalytics.Options,
    ) => {
        const localHookOptions = JSON.parse(JSON.stringify(hookOptions));
        if (localHookOptions?.cart && localHookOptions?.cart?.cartLines) {
            const lines = localHookOptions?.cart?.cartLines;
            const mergedOptions = lines?.reduce((acc: any[], line: CartLineModel) => {
                line.sectionOptions?.forEach((option: any) => {
                    if (option.optionName === "Empty" || option.productId === null) {
                        return;
                    }
                    const kits = JSON.parse(line.properties.productsInKit);
                    const currentKit = kits.find((item: any) => item.ProductId === option.productId);
                    const existingOption = acc.find(item => {
                        return item.productId === currentKit.ProductId;
                    });
                    if (existingOption) {
                        existingOption.qtyOrdered += line.qtyOrdered;
                    } else {
                        acc.push({
                            uri: currentKit.ProductUrl,
                            erpNumber: currentKit.ProductSku,
                            productId: currentKit.ProductId,
                            shortDescription: option.optionName,
                            qtyOrdered: line.qtyOrdered,
                            qtyLeft: line.qtyLeft,
                        });
                    }
                });
                return acc;
            }, []);
            localHookOptions.cart.cartLines.push(...mergedOptions);
        }

        if (parameters.isMiniCart === true) {
            return ga.track.viewMiniCart({ ...hookParameters, ...parameters }, { ...localHookOptions, ...options });
        }

        return ga.track.viewCart({ ...hookParameters, ...parameters }, { ...localHookOptions, ...options });
    };
};

export default useTrackViewStoreCart;
